// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".estado-auditoria{right:15px}.estado-auditoria,.estado-auditoria-left{min-width:120px!important;position:absolute;top:10px}.estado-auditoria-left{right:155px}.theme--light.v-data-table.auditoria tbody tr:hover:not(.v-data-table__expand-row){background:#eee;cursor:context-menu!important}.isLocked *{cursor:pointer;opacity:.95;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
